// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import common from "@store/Themes/common/styleguide/components/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const titleStyles = (breakpoints: Array<Amount | null>) => css`
    ${spacingStyles("1em", "0.5em")}
    ${breakpointValues(pxToRemArray(breakpoints), "font-size")}
    color: ${getColor("text")};
    font-weight: ${x => x.theme.design.typography.weight.bold};
`;

const typography: Styleguide["typography"] = {
    ...common,
    fontFamilyImportUrl:
        "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
    h1: {
        css: css`
            ${common?.h1?.css}
            ${titleStyles([null, 31, 37, null, 45])}
        `,
    },
    h2: {
        css: css`
            ${common?.h2?.css}
            ${titleStyles([null, null, 31, null, 36])}
        `,
    },
    h3: {
        css: css`
            ${common?.h3?.css}
            ${titleStyles([null, null, 23, null, 26])}
        `,
    },
    h4: {
        css: css`
            ${common?.h4?.css}
            ${titleStyles([null, null, 18, null, 20])}
        `,
    },
    h5: {
        css: css`
            ${common?.h5?.css}
            ${titleStyles([null, null, null, null, 16])}
        `,
    },
    h6: {
        css: css`
            ${common?.h5?.css}
            ${titleStyles([null, null, null, null, 14])}
        `,
    },
};

export default typography;
